import { createTheme, rem } from '@mantine/core';

import { mantineComponents } from './MantineComponents';

// import '../../assets/fonts/Manrope/Manrope.css';

export const themeSettings = createTheme({
	fontFamily: 'Manrope, sans-serif',
	fontSizes: {
		xs: rem(10),
		sm: rem(12),
		md: rem(14),
		lg: rem(16),
		xl: rem(20),
	},
	colors: {
		fsoft: [
			'#4a4a4a',
			'#4a4a4a',
			'#4a4a4a',
			'#4a4a4a',
			'#4a4a4a',
			'#4a4a4a',
			'#4a4a4a',
			'#4a4a4a',
			'#4a4a4a',
			'#4a4a4a',
		],
		phs: [
			'#2f9e51',
			'#2f9e51',
			'#2f9e51',
			'#2f9e51',
			'#2f9e51',
			'#2f9e51',
			'#2f9e51',
			'#2f9e51',
			'#2f9e51',
			'#2f9e51',
		],
		lab: [
			'#B70023',
			'#B70023',
			'#B70023',
			'#B70023',
			'#B70023',
			'#B70023',
			'#B70023',
			'#B70023',
			'#B70023',
			'#B70023',
		],
		default: [
			'#2f9e51',
			'#2f9e51',
			'#2f9e51',
			'#2f9e51',
			'#2f9e51',
			'#2f9e51',
			'#2f9e51',
			'#2f9e51',
			'#2f9e51',
			'#2f9e51',
		],
		red: [
			'#ffe9e9',
			'#ffd1d1',
			'#fba0a1',
			'#f76d6d',
			'#f34141',
			'#f22625',
			'#f21616',
			'#d8070b',
			'#c10008',
			'#a90003',
		],
	},
	components: mantineComponents,
	defaultRadius: 'md',
	focusRing: 'never',
	cursorType: 'pointer',
});
